import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["errors"]

  connect() {
    this.onInvalid = (event) => this.reveal(event.target)
    this.element.addEventListener("invalid", this.onInvalid, true)
    if (this.hasErrorsTarget) {
      this.focusFrame = requestAnimationFrame(() => {
        this.focus(this.element.querySelector('[aria-invalid="true"]') || this.errorsTarget)
      })
    }
  }

  disconnect() {
    cancelAnimationFrame(this.focusFrame)
    this.element.removeEventListener("invalid", this.onInvalid, true)
  }

  focusError(event) {
    const target = document.getElementById(event.currentTarget.hash.slice(1))
    if (!target) return
    event.preventDefault()
    this.focus(target)
  }

  reveal(target) {
    const details = target.closest("details")
    if (details) details.open = true
  }

  focus(target) {
    this.reveal(target)
    target.focus({ preventScroll: true })
    target.scrollIntoView({ block: "center" })
  }
}
